import React from "react";

export const LazyWormMicrosoftTeamsViewerBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "ChatViewer" */ "./WormMicrosoftTeamsViewer"
        )
);
